import { Injectable } from "@angular/core";
import { BaseApiService } from "../shared/_base.api.service";

import { Contact } from "../../utils/types/admon/contact.type";
import { ContactMapper } from "../../utils/mappers/admon/contact.mapper";
import { CONTACT_ENDPOINTS } from "../../components/mediaManager/admon/company/company-endpoints";
import { FilterType } from "../../utils/types/shared/_filter.type";
import { PagedApiResponse } from "../../utils/types/shared/_paged-api-response.type";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { HttpParams } from "@angular/common/http";

@Injectable()
export class ContactService extends BaseApiService<Contact> {
    model = Contact;
    mapper = new ContactMapper();
    apiEndPoint: any = CONTACT_ENDPOINTS;

    getList(
        filter?: FilterType,
        companyId?: number
    ): Observable<PagedApiResponse<Contact>> {
        let params = new HttpParams();
        params = params.append("offset", filter.offset);
        params = params.append("limit", filter.limit);

        return this.http
            .get(
                this.apiEndPoint.list.replace(
                    "{companyId}",
                    companyId.toString()
                ),
                { params }
            )
            .pipe(
                map((res) => {
                    return this.sharedMapper.mapPagedApiResponse(
                        res,
                        this.mapper.mapList,
                        this.model
                    );
                })
            );
    }
    create(data: Contact): Observable<boolean> {
        return this.http
            .post<boolean>(
                this.apiEndPoint.base.replace(
                    "{companyId}",
                    data.companyId.toString()
                ),
                data
            )
            .pipe(
                map((res) => {
                    return res;
                })
            );
    }

    update(data: Contact): Observable<boolean> {
        const { companyId, id } = data;
        const endpoint = this.apiEndPoint.item
            .replace("{companyId}", companyId.toString())
            .replace("{id}", id.toString());
        return this.http.put<boolean>(endpoint, data);
    }

    delete(id: number, companyId?: number): Observable<boolean> {
        const endpoint = this.apiEndPoint.item
            .replace("{companyId}", companyId.toString())
            .replace("{id}", id.toString());
        return this.http.delete<boolean>(endpoint);
    }
}
